import { render, staticRenderFns } from "./XAIDetails.vue?vue&type=template&id=a4bef4f6&scoped=true&"
import script from "./XAIDetails.vue?vue&type=script&lang=js&"
export * from "./XAIDetails.vue?vue&type=script&lang=js&"
import style0 from "./XAIDetails.vue?vue&type=style&index=0&id=a4bef4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bef4f6",
  null
  
)

export default component.exports